import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {p, pb} from "@pg-design/helpers-css-strings";

interface ISidebarProps {
    animation: boolean;
}

export const OfferSidebar = styled.div<ISidebarProps>`
    position: absolute;
    transform: translateX(100%);
    bottom: 0;
    top: 0;
    width: 0;
    right: 0;
    overflow-y: auto;
    background-color: ${(props) => props.theme.colors.gray[100]};
    visibility: hidden;

    ${(props) =>
        props.animation &&
        css`
            visibility: visible;
            transform: translateX(0);
            transition: transform 500ms;
            width: 100%;
            ${pb(2.5)};

            @media (min-width: ${props.theme.breakpoints.md}) {
                min-width: 57.3rem;
                width: 42%;
                ${p(0, 1.5, 1.5, 1.5)};
            }
        `}
`;
import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {p, pb} from "@pg-design/helpers-css-strings";

interface ISidebarProps {
    animation: boolean;
}

export const OfferSidebar = styled.div<ISidebarProps>`
    position: absolute;
    transform: translateX(100%);
    bottom: 0;
    top: 0;
    width: 0;
    right: 0;
    overflow-y: auto;
    background-color: ${(props) => props.theme.colors.gray[100]};
    visibility: hidden;

    ${(props) =>
        props.animation &&
        css`
            visibility: visible;
            transform: translateX(0);
            transition: transform 500ms;
            width: 100%;
            ${pb(2.5)};

            @media (min-width: ${props.theme.breakpoints.md}) {
                min-width: 57.3rem;
                width: 42%;
                ${p(0, 1.5, 1.5, 1.5)};
            }
        `}
`;
